import { isPlainObject, isArray, each } from "lodash";
export default function stripEtag(data) {
    if (isArray(data)) {
        each(data, function (item) { return stripEtag(item); });
    }
    else if (isPlainObject(data)) {
        data.etag = undefined; // inconsitency in BE services
        data.Etag = undefined;
        each(data, function (item) {
            if (shouldIterate(item))
                stripEtag(item);
        });
    }
}
function shouldIterate(obj) {
    return isPlainObject(obj) || Array.isArray(obj);
}
